import styled from 'styled-components';

export const Table = styled.table`
    table-layout: fixed;
    width: 100%;
    thead {
        font-weight: 400;
    }

    th,
    td {
        padding: 0 0.5rem;
        font-size: 0.7rem;
        text-align: left;
        white-space: pre-wrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: top;
    }

    td {
        font-size: 0.75rem;
    }
    .col-rob {
        text-align: right;
        width: 95px;
    }
    .bold-col {
        font-weight: 500;
    }
`;
